import { clsx } from 'clsx/lite'
import React, { type PropsWithChildren } from 'react'

export type SegmentItemProps = {
  selected?: boolean
  disabled?: boolean
  label?: string
  value?: string
} & React.HTMLAttributes<HTMLLabelElement>

export const SegmentItem: React.FC<PropsWithChildren<SegmentItemProps>> = ({
  selected = false,
  disabled = false,
  children,
  ...props
}) => (
  <label
    className={clsx(
      'relative mr-1 flex flex-1 items-center justify-center rounded-md p-2 text-center leading-5 last:mr-0 mobileL:min-w-28 mobileL:px-9 mobileL:py-1',
      selected
        ? 'bg-grey-900 font-medium text-white-50'
        : 'text-grey-900 hover:bg-slate-50',
      disabled ? 'cursor-default opacity-50' : 'cursor-pointer'
    )}
    {...props}
  >
    {children}
  </label>
)
